const settings = {
	viewDFormat: 'dd. MM. yyyy',
	viewDtFormat: 'dd.MM.yyyy HH:mm',
	filterTimeoutLength: 1000,
	emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
	notificationMethodOptions: [
		{ value: 'email', label: 'Elektronski naslov' },
		{ value: 'halcom', label: 'Halcom' },
		{ value: 'none', label: 'Brez' },
	],
	orderTypeOptions: [
		{ value: 'single', label: 'Enkratna' },
		{ value: 'multiple', label: 'Terminska' },
	],
	ebillAreaOptions: [
		{
			label: 'CDP',
			value: 'CDP',
			active: false
		},
		{
			label: 'Toyota',
			value: 'Toyota',
			active: false
		},
		{
			label: 'Form.NET',
			value: 'Form.NET',
			active: false
		},
		{
			label: 'Vasco',
			value: 'Vasco',
			active: false
		}
	],
	ebillStatusOptions: [
		{
			label: 'V pripravi',
			value: 'inPreparation',
			active: false
		},
		{
			label: 'Pripravljen',
			value: 'prepared',
			active: false
		},
		{
			label: 'Poslan',
			value: 'sended',
			active: false
		}
	],
	spOrderDepartmentOptions: [
		{ value: 'kleparski', label: 'KLE.', active: false },
		{ value: 'mehanični', label: 'MEH.', active: false }
	],
	spOrderLocationOptions: [
		{ value: 'workshop', label: 'V delavnici', active: false },
		{ value: 'driving', label: 'Se vozi', active: false },
		{ value: 'partlyRepared-driving', label: 'Delno popravljeno - Se vozi', active: false },
		{ value: 'yard', label: 'Dvorišče', active: false },
	],
	spOrderItemsStatusOptions: [
		{
			label: 'Čakam dobavitelja',
			value: '100',
			variant: 'danger',
			active: false
		},
		{
			label: 'Naročeno',
			value: '200',
			variant: 'warning',
			active: false
		},
		{
			label: 'Na zalogi',
			value: '300',
			variant: 'success',
			active: false
		},
		{
			label: 'V pripravi',
			value: '#',
			variant: 'light',
			active: false
		},
	],
	newItemDefaultStatusIndex: 1,
	spOrderWarrantyOptions: [
		{ value: 'no', label: 'Ne', active: false },
		{ value: 'yes', label: 'Da', active: false },
		{ value: 'guarantee', label: 'Jamstvo', active: false }
	],
	replacementVehicleDepartmentOptions: [
		{ value: 'kleparski', label: 'KLE.', active: false },
		{ value: 'mehanični', label: 'MEH.', active: false }
	],
	replacementVehicleTiresOptions: [
		{ value: 'Z', label: 'Zimske', active: false, icon: 'cil-snowflake', variant: 'info' },
		{ value: 'L', label: 'Letne', active: false, icon: 'cil-sun', variant: 'warning' }
	],
	yesNoLabelTxt: {
		labelOn: 'Da',
		labelOff: 'Ne'
	},
	reservationColors: [
		'#4CAF50', // Green
		'#2196F3', // Blue
		'#9C27B0', // Purple
		'#FF9800', // Orange
		'#E91E63', // Pink
		'#00BCD4', // Cyan
		'#8BC34A', // Light Green
		'#3F51B5', // Indigo
		'#FF5722', // Deep Orange
		'#009688'  // Teal
	],
}
export default settings
